(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;
		observer.unobserve(productRecommendationsSection);
		const url = productRecommendationsSection.dataset.url;
		console.log('[YMAL] Loading recommendations from:', url);
		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations');
				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
					console.log('[YMAL] Recommendations loaded successfully');
					// Execute any script tags that were in the loaded content
					const scripts = productRecommendationsSection.querySelectorAll('script');
					scripts.forEach(script => {
						const newScript = document.createElement('script');
						newScript.textContent = script.textContent;
						document.head.appendChild(newScript);
						document.head.removeChild(newScript);
					});
				} else {
					console.log('[YMAL] No recommendations found');
				}
			})
			.catch(e => {
				console.error('[YMAL] Error loading recommendations:', e);
			});
	};
	const productRecommendationsSection = document.querySelector('.product-recommendations');
	const observer = new IntersectionObserver(handleIntersection);
	observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
